import React from "react";
import {css} from "@emotion/react";

import {ToggleButton} from "@pg-design/button-module";
import {calculateRemSize, flex, flexAbsoluteCenter, onDesktop} from "@pg-design/helpers-css";
import {AirportIcon, BeachIcon, MapMarkerLocationIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {InvestmentOfferTypeSlug} from "../../investment_offer/constants/investment_offer_constants";
import {GTMEvent, propertyConfiguratorAnalytics} from "../analytics/events";
import {SearchListingInvestmentViewType, useSearchListingInvestmentViewType} from "../hooks/use_search_listing_investment_view_type";

interface IProps {
    isMap?: boolean;
}

export const ListingChangingButtons = (props: IProps) => {
    const searchListingInvestmentViewType = useSearchListingInvestmentViewType();

    const links = [
        {
            href: props.isMap
                ? rpAppLink.offer.mapFriendly({friendlySlug: "nowe-mieszkania-i-domy"})
                : rpAppLink.offer.listFriendly({friendlySlug: "nowe-mieszkania-i-domy"}),
            icon: <MapMarkerLocationIcon size="2.4" />,
            text: "W Polsce",
            isActive: searchListingInvestmentViewType === SearchListingInvestmentViewType.PL
        },
        {
            href: props.isMap
                ? rpAppLink.offer.mapAbroadCountry({friendlySlug: "nowe-mieszkania-i-domy", country: "hiszpania"})
                : rpAppLink.offer.listFriendlyAbroad({friendlySlug: "nowe-mieszkania-i-domy", country: "hiszpania"}),
            icon: <AirportIcon size="2.4" />,
            text: "W Hiszpanii",
            isActive: searchListingInvestmentViewType === SearchListingInvestmentViewType.ABROAD
        },
        {
            href: props.isMap
                ? rpAppLink.investmentOffer.investmentCategory.map({category: InvestmentOfferTypeSlug.HOLIDAY})
                : rpAppLink.investmentOffer.investmentCategory.base({category: InvestmentOfferTypeSlug.HOLIDAY}),
            icon: <BeachIcon size="2.4" />,
            text: "Wakacyjne",
            isActive: searchListingInvestmentViewType === SearchListingInvestmentViewType.HOLIDAY
        }
    ];

    const handleClick = (buttonText: string) => {
        propertyConfiguratorAnalytics.gtm.searchEvent(GTMEvent.LISTING_CHANGING_BUTTON, {search_buttons_type: buttonText});
    };

    return (
        <div css={buttonsWrapper}>
            {links.map((link, index) => (
                <ToggleButton
                    as="a"
                    css={buttonStyle}
                    key={index}
                    href={link.href}
                    onClick={() => handleClick(link.text)}
                    target="_blank"
                    isActive={link.isActive}
                    icon={link.icon}
                >
                    {link.text}
                </ToggleButton>
            ))}
        </div>
    );
};

const buttonsWrapper = css`
    ${flexAbsoluteCenter};
    gap: ${calculateRemSize(1)};
    display: flex;

    ${onDesktop(flex("center", "flex-start"))};
`;

const buttonStyle = css`
    flex: 1 0;
`;
import React from "react";
import {css} from "@emotion/react";

import {ToggleButton} from "@pg-design/button-module";
import {calculateRemSize, flex, flexAbsoluteCenter, onDesktop} from "@pg-design/helpers-css";
import {AirportIcon, BeachIcon, MapMarkerLocationIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {InvestmentOfferTypeSlug} from "../../investment_offer/constants/investment_offer_constants";
import {GTMEvent, propertyConfiguratorAnalytics} from "../analytics/events";
import {SearchListingInvestmentViewType, useSearchListingInvestmentViewType} from "../hooks/use_search_listing_investment_view_type";

interface IProps {
    isMap?: boolean;
}

export const ListingChangingButtons = (props: IProps) => {
    const searchListingInvestmentViewType = useSearchListingInvestmentViewType();

    const links = [
        {
            href: props.isMap
                ? rpAppLink.offer.mapFriendly({friendlySlug: "nowe-mieszkania-i-domy"})
                : rpAppLink.offer.listFriendly({friendlySlug: "nowe-mieszkania-i-domy"}),
            icon: <MapMarkerLocationIcon size="2.4" />,
            text: "W Polsce",
            isActive: searchListingInvestmentViewType === SearchListingInvestmentViewType.PL
        },
        {
            href: props.isMap
                ? rpAppLink.offer.mapAbroadCountry({friendlySlug: "nowe-mieszkania-i-domy", country: "hiszpania"})
                : rpAppLink.offer.listFriendlyAbroad({friendlySlug: "nowe-mieszkania-i-domy", country: "hiszpania"}),
            icon: <AirportIcon size="2.4" />,
            text: "W Hiszpanii",
            isActive: searchListingInvestmentViewType === SearchListingInvestmentViewType.ABROAD
        },
        {
            href: props.isMap
                ? rpAppLink.investmentOffer.investmentCategory.map({category: InvestmentOfferTypeSlug.HOLIDAY})
                : rpAppLink.investmentOffer.investmentCategory.base({category: InvestmentOfferTypeSlug.HOLIDAY}),
            icon: <BeachIcon size="2.4" />,
            text: "Wakacyjne",
            isActive: searchListingInvestmentViewType === SearchListingInvestmentViewType.HOLIDAY
        }
    ];

    const handleClick = (buttonText: string) => {
        propertyConfiguratorAnalytics.gtm.searchEvent(GTMEvent.LISTING_CHANGING_BUTTON, {search_buttons_type: buttonText});
    };

    return (
        <div css={buttonsWrapper}>
            {links.map((link, index) => (
                <ToggleButton
                    as="a"
                    css={buttonStyle}
                    key={index}
                    href={link.href}
                    onClick={() => handleClick(link.text)}
                    target="_blank"
                    isActive={link.isActive}
                    icon={link.icon}
                >
                    {link.text}
                </ToggleButton>
            ))}
        </div>
    );
};

const buttonsWrapper = css`
    ${flexAbsoluteCenter};
    gap: ${calculateRemSize(1)};
    display: flex;

    ${onDesktop(flex("center", "flex-start"))};
`;

const buttonStyle = css`
    flex: 1 0;
`;
